
import { JobService } from "@/services/job-service";
import Vue from "vue";
import { BookYearService } from "../../services/book-year-service";
import { AuthService } from "../../services/auth-service";
import { MODULE } from "../../config/modules";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { UserConfigService } from "@/services/user-config-service";
import AppAccountingStockEmptyModal from "./AccountingStockEmptyModal.vue";
import AppAccountingStockRecomputeModal from "./AccountingStockRecomputeModal.vue";
import { SaleService, DossierConfigService } from "@/services";
import { TranslateResult } from "vue-i18n";
import { printLocalDateTime } from "@/utils/pretty-print";


export default Vue.extend({
	data() {
		return {
			JobService,
			module: MODULE.VOORRAADBEHEER,
			hasNewerBookYear: (BookYearService.getNewestBookYear().Year > BookYearService.selectedBookYear),
			accountingStockEmptyModalOpen: false,
			accountingStockRecomputeModalOpen: false,
			DossierConfigService,
			currentBookYearObj: BookYearService.selectedBookYearObj
		};
	},
	computed: {
		overwriteStockRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "overwrite-stock") != -1;
		},
		recalculateStockRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "compute-stock") != -1;
		},
		emptyingStockRunnig():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "empty-stock") != -1;
		},
		hasStockModule():boolean {
			return AuthService.hasModule(this.module);
		},
		emptyStockDisabled():boolean {
			if (!UserConfigService.hasCurrentUserPermission(p=>p.IsAdmin)){
				return true;
			}
			return false;
		},
		copyBackorderSalesRunning():boolean{
			return this.JobService.getJobs().findIndex(a => a.Name == "copy-backorder-sales") != -1;
		},
		canCopyBackorderSales():boolean {
			if (!this.hasNewerBookYear){
				return false;
			}
			if (this.copyBackorderSalesRunning) {
				return false;
			}
			return AuthService.hasModule(MODULE.BACKORDERBEHEER);
		},
		isShowNegativeAmountsOnInventoryReport():boolean {
			return this.DossierConfigService.getStockLocationConfig().ShowNegativeValuesOnInventoryReport;
		},
		isOutOfStockSelectedSupplierSelectGroup():boolean {
			return this.DossierConfigService.getStockLocationConfig().OutOfStockSelectedSupplierSelectGroup;
		},
		isShowInfoFieldOnStockIn():boolean {
			return this.DossierConfigService.getStockLocationConfig().ShowInfoFieldOnStockIn;
		}
	},
	methods: {
		async overwriteStock() {
			await BookYearService.overwriteStock();
		},
		async computeStock() {
			this.accountingStockRecomputeModalOpen = true;
		},
		async emptyStock(){
			this.accountingStockEmptyModalOpen = true;
		},
		async copyBackorderSales(){
			await SaleService.copyBackordersToNewBookYear();
		},
		async toggleShowNegativeAmountsOnInventoryReport(value:boolean){
			let settings = this.DossierConfigService.getStockLocationConfig();
			settings.ShowNegativeValuesOnInventoryReport = value;
			await this.DossierConfigService.saveStockLocationConfig(settings);
		},
		async toggleOutOfStockSelectedSupplierSelectGroup(value:boolean){
			let settings = this.DossierConfigService.getStockLocationConfig();
			settings.OutOfStockSelectedSupplierSelectGroup = value;
			await this.DossierConfigService.saveStockLocationConfig(settings);
		},
		async toggleShowInfoFieldOnStockIn(value:boolean){
			let settings = this.DossierConfigService.getStockLocationConfig();
			settings.ShowInfoFieldOnStockIn = value;
			await this.DossierConfigService.saveStockLocationConfig(settings);
		},
		getLastExecutedText(date:Date | null):string | TranslateResult{
			if (!date) return "";
			return this.$ct("last-executed-on", {date: printLocalDateTime(date)}) ;
		}
	},
	components: {
		AppMissingModule,
		AppAccountingStockEmptyModal,
		AppAccountingStockRecomputeModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
